<template>
    <div>
        <Table ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight"></Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showOrderConsult"
            :title="dataSource + '咨询'"
            :width="800"
            :height="650"
            :maskClosable="false"
            :buttons="buttons"
            @on-hidden="search"
        >
            <form-order-consult v-if="modal.showOrderConsult" :id="curId"></form-order-consult>
        </smart-modal>
        <smart-modal
            v-model="modal.showOrderInfo"
            :title="dataSource + '详情'"
            :width="800"
            :height="650"
            :maskClosable="false"
            :buttons="buttons"
            @close-by-confirm="search"
        >
            <form-order v-if="modal.showOrderInfo" :id="curId"></form-order>
        </smart-modal>
    </div>
</template>
<script>
import { anchorCell } from '_c/grid/renderCell'
import FormOrderConsult from './form-order-consult'
import { statisticOrderConsult } from '@/api/order-manage'
import FormOrder from '@/views/order-manage/form-order'
const PAGE_SIZE = 20

export default {
    name: 'ListOrderConsult',

    components: {
        FormOrderConsult,
        FormOrder
    },
    props: {
        date: Object
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                orderDataSource: this.$cache.orderDataSource,
                pageNo: 1,
                pageSize: PAGE_SIZE
            },
            page: {
                total: 0,
                list: []
            },
            dict: {},
            modal: {
                showOrderConsult: false,
                showOrderInfo: false
            },
            curId: '',
            buttons: [
                {
                    type: 'default',
                    text: '关闭'
                }
            ]
        }
    },

    computed: {
        columns() {
            let that = this
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'orderNo',
                    title: '工单号',
                    align: 'left',
                    minWidth: 180,
                    render: anchorCell({
                        click(row, column, index) {
                            that.toShowInfo(row)
                        }
                    })
                },
                {
                    key: 'content',
                    title: '最新咨询',
                    align: 'left',
                    minWidth: 200,
                    tooltip: true
                },
                {
                    key: 'total',
                    title: '咨询总数',
                    align: 'center',
                    minWidth: 100,
                    render: anchorCell({
                        click(row, column, index) {
                            that.toShowConsult(row)
                        }
                    })
                }
            ]
        },
        dataSource() {
            return this.filter.orderDataSource == 'G' ? '工单' : '任务'
        }
    },

    watch: {
        date: {
            handler(val) {
                this.search()
            },
            deep: true
        }
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true
            let date = Object.assign({}, this.date)
            let body = Object.assign(date, this.filter)
            Promise.all([statisticOrderConsult(body)])
                .then(args => {
                    var [page] = args
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            let list = data.page.list
            list.forEach(el => {
                // 处理【】【】【content】格式的消息
                el.content = el.content
                    ? (el.content.split('【')[3] || '').split('】')[0]
                    : ''
            })
            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },

        toShowInfo(row) {
            this.curId = row.id
            this.modal.showOrderInfo = true
        },

        toShowConsult(row) {
            this.curId = row.id
            this.modal.showOrderConsult = true
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>